// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
 // url: {
 //   Bululk_eligibility: 'https://developer-api.cerebrumx.ai/api/v3/',
 //   BASE_URL: 'https://developer-api.cerebrumx.ai/api/v1/',
//trip_URL: 'https://developer-api.cerebrumx.ai/api/',
 //   BASE_URL_1:'https://developer-api.cerebrumx.ai/api/',
 //   CHAT_BOT: 'https://cx-chatbot.cerebrumx.ai/v1/',
 //}

 url: {
   Bululk_eligibility: 'https://denali.cerebrumx.ai/d1/api/v3/',
   BASE_URL: 'https://denali.cerebrumx.ai/d1/api/v1/',
   trip_URL: 'https://denali.cerebrumx.ai/d1/api/',
   BASE_URL_1:'https://denali.cerebrumx.ai/d1/api/',
   CHAT_BOT: 'https://denali.cerebrumx.ai/d1/api/',
 }
}


